/* Dona Manis — Theme JavaScript */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Sticky nav scroll state ─────────────────────────────────── */
  var nav = document.querySelector('.dm-nav');
  if (nav) {
    // Only apply transparent nav on homepage
    var isHomepage = window.location.pathname === '/' || window.location.pathname === '';

    if (isHomepage) {
      nav.classList.add('dm-nav-transparent');
    }

    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        nav.classList.add('scrolled');
        nav.classList.remove('dm-nav-transparent');
      } else {
        nav.classList.remove('scrolled');
        if (isHomepage) {
          nav.classList.add('dm-nav-transparent');
        }
      }
    });

    // Trigger once on load in case page is already scrolled
    if (window.scrollY > 60) {
      nav.classList.add('scrolled');
      nav.classList.remove('dm-nav-transparent');
    }
  }

  /* ── Mobile hamburger toggle ─────────────────────────────────── */
  var hamburger = document.querySelector('.dm-hamburger');
  var mobileMenu = document.querySelector('.dm-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
    });
  }

  /* ── Smooth scroll for anchor links ─────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        if (mobileMenu) mobileMenu.classList.remove('open');
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  /* ── Scroll reveal ───────────────────────────────────────────── */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { observer.observe(el); });
  } else {
    /* Fallback for older browsers */
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ── Email signup form ───────────────────────────────────────── */
  var emailForm = document.querySelector('.dm-email-form');
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailBox = document.querySelector('.dm-email-box');
      if (emailBox) {
        emailBox.innerHTML = '<div class="dm-email-success"><p class="dm-display" style="font-size:1.25rem;color:#D4A84B;margin-bottom:0.5rem;">Welcome to The Heritage Table.</p><p style="font-size:0.75rem;color:#C4922A;font-weight:300;">We\'ll be in touch with what\'s baking this week.</p></div>';
      }
    });
  }

});
